import { EventEmitter2 } from "eventemitter2";

import { FileStorage } from "../lib/storage";
import { AutoCompleteService } from "../lib/ui/autocomplete";
import { I18n } from "../lib/i18n";
import { NavigateService } from "../lib/routing";
import { NotificationService } from "../lib/dialogs";

export const docStore = new FileStorage("doc");
export const persistStore = new FileStorage("persist");

export const eventEmitter = new EventEmitter2();

export const navigate = new NavigateService();
export const notification = new NotificationService();
export const autoComplete = new AutoCompleteService();
export const i18n = new I18n();
